import { queryOptions } from '@tanstack/react-query';
import { api, unwrap, type Schemas } from '@/api/client';
import { qk } from '@/api/queries';

export { plansQuery } from '@/api/queries';
import type { Plan, SubscriptionReport, SubscriptionRow } from '@/api/types';

export type { Plan };
export type Subscription = SubscriptionRow;
export type SubscriptionsReport = SubscriptionReport;


export const subscriptionsQuery = queryOptions({
  queryKey: qk.subscriptions,
  queryFn: () => unwrap(api.GET('/admin/subscriptions')),
});

export const subscriptionsReportQuery = queryOptions({
  queryKey: qk.subscriptionsReport,
  queryFn: () => unwrap(api.GET('/admin/reports/subscriptions')),
});

export function updatePlan(id: string, body: Schemas['PlanPatch']) {
  return unwrap(api.PATCH('/admin/plans/{plan_id}', { params: { path: { plan_id: id } }, body }));
}
